import { useEffect, useState } from "react";
import { useAppDispatch } from "../../app/hook";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  SpaceBetween,
  ColumnLayout,
  Box,
  Container,
} from "@cloudscape-design/components-themed";
import { showModal } from "../UI/modal/modal-slice";
import { Tab } from "./InfoTab";
import CorpInfoForm from "./CorpInfoForm";
import { COMMON_LABELS } from "../default-constants";
import {
  useGetMerchantInfoResponseQuery,
  useGetAuthQuery,
} from "../../features/api";
import { MerchantInfoResponse } from "../../features/api-interfaces";

export const MainForm = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { code } = useParams();
  //直接契約か包括契約かのフラグ
  const isDirect = code === ":code";

  //申請事業者情報
  const [corpInfoData, setCorpInfoData] = useState({
    companyCode: "",
    corporateNumber: "",
    companyName: "",
    companyNameKana: "",
    address1: "",
    address2: "",
    companyNameAlphabetical: "",
    contractStyles: [],
    address: "",
    postalCode: "",
    phoneNumber: "",
    dunsNumber: "",
    businessStyle: Number(""),
    tradeNameLegalPersonality: "",
    nameItemScreenDisplay: [],
    addressKana: "",
    companyUrl: "",
    establishmentYearMonth: "",
    capital: "",
    employeeNumber: Number(""),
    surveyDate: "",
    repName: "",
    repNameKana: "",
    repNameAlphabetical: "",
    repBirthdate: "",
    repCountry: "",
    companySituationName: "",
    score: Number(""),
    orderAdaptationDate: "",
    changedFlag: false,
    addressList: [],
  } as MerchantInfoResponse);

  const { companyId, companyType } = useGetAuthQuery(undefined, {
    selectFromResult: ({ data }) => ({
      companyId: data?.companyCode,
      companyType: data?.companyType,
    }),
  });

  // 申請事業者情報情報を取得
  const companyCode = isDirect ? companyId : code;
  const { data: corpInfo } = useGetMerchantInfoResponseQuery(companyCode, {
    skip: !companyCode,
  });

  useEffect(() => {
    if (corpInfo) {
      setCorpInfoData(corpInfo);
    }
  }, [corpInfo]);

  //TODO：今後変数名とオブジェクトをAPIに合わせて修正
  //TODO：今後親でAPIでデータを取るか、本来初期化は空にすべき、APIで取ってきたらデータを入れる
  // 代表者情報（モック）
  const [accessInfo, setAccessInfo] = useState({
    contractStyle: "",
    inclusionMerchant: "",
  });

  //エラーメッセージ
  const [accessInfoErrorMsg, setAccessInfoErrorMsg] = useState({
    contractStyle: "",
    inclusionMerchant: "",
  });

  //TODO：今後変数名とオブジェクトをAPIに合わせて修正
  //TODO：今後親でAPIで取るか
  // サイトID選択肢（モック）
  const contractStyleItems = [
    { value: "1", label: "直接契約" },
    { value: "2", label: "包括契約" },
  ];

  //戻るボタン押下時のダイアログ
  const returnToLastPage = () => {
    //最初のページにいる場合、親のページに戻る
    dispatch(
      showModal({
        title: COMMON_LABELS.TITLES.DL,
        content: COMMON_LABELS.CONTENTS.PAGE_MOVE_CONFIRM,
        positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
        negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
        positiveFn: () => {
          navigate("/merchants?isBackFromDetail=true");
        },
      })
    );
  };

  return (
    <SpaceBetween direction="vertical" size="l">
      <form onSubmit={(e) => e.preventDefault()}>
        <SpaceBetween direction="vertical" size="l">
          <CorpInfoForm
            corpInfo={corpInfoData}
            hasCreatedBy={""}
            hasCreatedAt={""}
          />

          <Container>
            <Tab
              companyCode={companyCode}
              companyType={companyType}
              storeInfo={companyCode}
              corpInfo={corpInfoData}
              groupData={companyCode}
              accessInfo={accessInfo}
              setAccessInfo={setAccessInfo}
              accessInfoErrorMsg={accessInfoErrorMsg}
              setAccessInfoErrorMsg={setAccessInfoErrorMsg}
              contractStyleItems={contractStyleItems}
            />
          </Container>
          <ColumnLayout columns={2}>
            {!isDirect && (
              <Box float="left">
                <Button
                  formAction="none"
                  variant="link"
                  onClick={returnToLastPage}
                >
                  {COMMON_LABELS.BTNS.BACK}
                </Button>
              </Box>
            )}
          </ColumnLayout>
        </SpaceBetween>
      </form>
    </SpaceBetween>
  );
};
